import React, { useState } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Calendar, Calculator, ArrowRight, Star } from 'lucide-react';

export const NumerologyPage = () => {
  const [birthDate, setBirthDate] = useState('');
  const [fullName, setFullName] = useState('');
  const [isCalculating, setIsCalculating] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsCalculating(true);
    
    // Simulate calculation process
    setTimeout(() => {
      setIsCalculating(false);
      alert('Fitur ini akan segera tersedia! Analisis numerologi Anda sedang dalam pengembangan.');
    }, 2000);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-amber-50 to-rose-50">
      <Header />
      
      {/* Hero Section */}
      <section className="pt-24 pb-16">
        <div className="container max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 bg-white/80 backdrop-blur-sm border border-amber-200 rounded-full px-4 py-2 mb-6">
            <Star className="h-4 w-4 text-amber-600" />
            <span className="body-small text-amber-800 font-mono uppercase tracking-wider">
              Analisis Numerologi Personal
            </span>
          </div>
          
          <h1 className="heading-hero mb-6">
            Temukan Rahasia Dirimu<br />
            Melalui Numerologi
          </h1>
          
          <p className="body-large text-gray-600 mb-8 max-w-2xl mx-auto">
            Masukkan tanggal lahir dan nama lengkap untuk mendapatkan analisis 
            numerologi yang komprehensif dan personal.
          </p>
        </div>
      </section>

      {/* Form Section */}
      <section className="pb-16">
        <div className="container max-w-2xl mx-auto">
          <div className="bg-white rounded-2xl shadow-lg border border-gray-100 p-8">
            <div className="text-center mb-8">
              <Calculator className="h-12 w-12 text-amber-600 mx-auto mb-4" />
              <h2 className="heading-2 mb-2">Kalkulator Numerologi</h2>
              <p className="body-medium text-gray-600">
                Dapatkan wawasan mendalam tentang kepribadian dan potensi Anda
              </p>
            </div>
            
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label htmlFor="fullName" className="block body-medium font-medium text-gray-700 mb-2">
                  Nama Lengkap
                </label>
                <input
                  type="text"
                  id="fullName"
                  value={fullName}
                  onChange={(e) => setFullName(e.target.value)}
                  placeholder="Masukkan nama lengkap Anda"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-amber-500 transition-colors"
                  required
                />
              </div>
              
              <div>
                <label htmlFor="birthDate" className="block body-medium font-medium text-gray-700 mb-2">
                  Tanggal Lahir
                </label>
                <input
                  type="date"
                  id="birthDate"
                  value={birthDate}
                  onChange={(e) => setBirthDate(e.target.value)}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-amber-500 transition-colors"
                  required
                />
              </div>
              
              <button
                type="submit"
                disabled={isCalculating || !birthDate || !fullName}
                className="w-full btn-primary py-4 text-lg disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-3"
              >
                {isCalculating ? (
                  <>
                    <div className="animate-spin rounded-full h-5 w-5 border-2 border-white border-t-transparent"></div>
                    Menghitung Numerologi...
                  </>
                ) : (
                  <>
                    <Calendar className="h-5 w-5" />
                    Analisis Sekarang
                    <ArrowRight className="h-5 w-5" />
                  </>
                )}
              </button>
            </form>
            
            <div className="mt-8 p-6 bg-amber-50 border border-amber-200 rounded-xl">
              <h3 className="heading-3 mb-3 text-amber-800">Yang Akan Anda Dapatkan:</h3>
              <ul className="space-y-2">
                <li className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-amber-500 rounded-full mt-2"></div>
                  <span className="body-medium text-amber-700">
                    Life Path Number dan maknanya dalam perjalanan hidup Anda
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-amber-500 rounded-full mt-2"></div>
                  <span className="body-medium text-amber-700">
                    Analisis kepribadian berdasarkan Expression Number
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-amber-500 rounded-full mt-2"></div>
                  <span className="body-medium text-amber-700">
                    Kekuatan dan tantangan dalam pertumbuhan personal
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-amber-500 rounded-full mt-2"></div>
                  <span className="body-medium text-amber-700">
                    Panduan untuk hubungan, karir, dan pengembangan diri
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default NumerologyPage;